














































































































import { Component, Prop } from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import subscriptionApi, { SubscriptionApi } from '@/views/settings/subscription/api';
import apiSubs, { AppExeptionsDialogsApi } from '@/components/app-exceptions-resolver/dialogs/api';

import { mixins } from 'vue-class-component';
import PaymentStatusMixin from '@/views/layout/navigation/mixins/payment-status-mixin';
import Template from '@/views/reports/forms/traffic_sources/template.vue';
import ModalHeader from '@/components/ui/ui-modal/modal/header.vue';
import UiLogout from '@/components/ui/ui-logout.vue';
import { AppErrorEnum } from '@/services/models/Enums';
import Vue from 'vue';
import UserApi from '@/services/rest/bemob/user';
import ChangePlan_step2 from './change-plan_step2.vue';
import ForbiddenToChangePlan from './forbidden-to-change-plan.vue';
import ChangePlanItem from './change-plan-item.vue';
import ChangePlanDetails from './change-plan-details.vue';
import _ from 'lodash';
import { availablePlanLimits } from '@/services/rest/bemob/billing';

enum Modes {
  step1 = 'step1',
  step2 = 'step2',
  planDetails = 'planDetails',
  cantDowngrade = 'cantDowngrade'
}

export interface Data {
  dontClose: boolean;
  registration: boolean;
  actionAfterLoad: Function;
  preSelectedPlan: Billing.BillingPlan;
  planLimits: null | BillingLimits;
}

@Component({
  components: {
    ChangePlan_step2,
    Template,
    FormOverlay,
    DialogForm,
    ModalHeader,
    UiLogout,
    ChangePlanItem,
    ChangePlanDetails,
    ForbiddenToChangePlan
  }
})
export default class ChangePlanDialog extends mixins(Form, PaymentStatusMixin) {
  show: boolean = false;
  edit: boolean = true;
  mode: Modes =  null;
  Modes = Modes;
  planId: string = '';
  selected: any = {};

  @Prop({
    default: {
      dontClose: false,
      registration: false,
      planLimits: null,
      actionAfterLoad:null
    }
  })
  data: Data;

  api: SubscriptionApi = subscriptionApi;
  apiExeptions: AppExeptionsDialogsApi = apiSubs;
  userApi: UserApi = new UserApi();
  interval = null;
  estimate = null;

  @Prop({ default: 'DD MMMM YYYY HH:mm' })
  format: string;

  currencyFormat: string = '0,0.00';

  get isAllowCloseButton() {
    return !(this.$store.state.appError === AppErrorEnum.freePlanLimitsExceeded || this.data.dontClose);
  }

  get isContinueDisabled() {
    return (
      this.state.loading ||
      /* if panel blocked, don't allow to go on basic or free */
      ((this.$store.state.appError === AppErrorEnum.freePlanLimitsExceeded || this.data.dontClose) &&
        (this.selected.id === 'basic' || this.selected.id === 'free'))
    );
  }

  get modalTitle() {
    if (this.data.registration) return this.t('Select Pricing Plan');
    if (this.data.planLimits) return this.t('Upgrade Subscription');
    return this.t('Change Plan');
  }

  get contentClass() {
    let result = ['change-plan-dialog', 'change-plan-dialog--' + this.mode];

    return result.join(' ');
  }

  load(): any {
    const plans: Promise<any> = this.api.getPlans();
    const data: Promise<any> = this.api.getSubscription();

    return Promise.all([plans, data]);
  }

  mounted() {
    this.$store.commit('loading', true);
    this.load().then(() => {
      this.$store.commit('loading', false);
      if(this.data.preSelectedPlan){
        this.handlePlanSelect(this.data.preSelectedPlan);
        this.handlePlanSelectConfirm().then(()=>{
          this.show = true;
          this.data.actionAfterLoad?.()
        });
      }else{
        this.selected = {
          id: this.subscriptionInfo.planId,
          name: this.subscriptionInfo.planName
        };
        this.mode = this.data.planLimits ? Modes.planDetails : Modes.step1
        this.show = true;
        this.data.actionAfterLoad?.()
      }
    });
  }

  updateSubscription(val: any) {
    this.$store.commit('loading', true);
    Vue.set(this.state, 'loading', true);
    this.api
      .postUpdateSubscriptions({ planId: val }, true)
      .then(() => {
        if (
          this.$store.state.user.blockedCampaigns ||
          this.$store.state.appError === AppErrorEnum.freePlanLimitsExceeded
        ) {
          this.interval = setInterval(async () => {
            const userData = await this.userApi.getUser();

            if (userData?.pendingInvoiceGeneration === false) {
              clearInterval(this.interval);
              window.location.reload();
            }
          }, 3000);
        } else {
          this.api.getSubscription();
          this.api.getCustomer();

          this.close();
          this.bus.emit('toast-success', this.t('Subscription plan successfully changed.'));
        }
      })
      .catch((err: any) => {
        if (err.response.status === 500) {
          this.bus.emit(
            'toast-error',
            this.t('Server Overload: Subscription change failed. Please try again later.')
          );
        } else {
          const errors = Object.values(err.response.data.errors);

          for (let error of errors) {
            if (error === 'VALIDATION_NO_CARD_PROVIDED') {
              this.bus.emit('open-update-payment-dialog');
            } else {
              // e.g. 'VALIDATION_CARD_EXPIRING'
              this.bus.emit('toast-error', this.t(String(error)));
            }
          }
        }
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
  }

  toPlan(planId: string) {
    this.planId = planId;

    this.$store.commit('loading', true);

    return this.api
      .postUpdateSubscriptionsEstimated({ planId: planId }, true)
      .then((data: any) => {
        if (!data.next_invoice_estimate && !data.invoice_estimate && planId !== 'basic' && planId !== 'free') {
          this.updateSubscription(planId);
        } else {
          this.estimate = data
          this.mode = Modes.step2;
          this.show = true;
        }
      })
      .catch((err: any) => {
        if (err.response.status === 500) {
          return this.bus.emit(
            'toast-error',
            this.t('Server Overload: Subscription change failed. Please try again later.')
          );
        }
        if (err.response.data.message === 'SUBSCRIPTION_UPDATE_FORBIDEN') {
          const {limits, usages} = err.response.data.payload
          this.$store.commit('setBilling',  {
            limits: _.pick(limits, availablePlanLimits),
            usage: _.pick(usages, availablePlanLimits)
          });
          this.handlePlanSelectConfirm()
        }
        if(err.response.data.message === 'SUBSCRIPTION_UPDATE_TOTAL_LESS_THAN_50_CENTS'){
          this.estimate = {
            ...err.response.data.payload,
            estimateType:'lessThan50cents'
          }
          this.mode = Modes.step2;
          this.show = true;
        }
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
  }

  close() {
    if (this.isAllowCloseButton) {
      this.$emit('close');
      clearInterval(this.interval);
    }
  }

  compareHandle() {
    this.$router.push('/app/profile/plan-description')
    this.bus.emit('close-all-dialogs');
  }

  byAsAddonHandle() {
    this.$emit('close');
    this.bus.emit('open-dialog',{name: 'manageAddon',data: {planLimit:this.data.planLimits}});
  }

  actionBeforeLogout() {
    this.$emit('close');
    clearInterval(this.interval);
  }

  handlePlanSelect(plan: Billing.BillingPlan) {
    this.selected = { ...plan };
  }

  handlePlanSelectConfirm() {
    const { planId } = this.subscriptionInfo;
    if (planId === this.selected.id) {
      this.close();
      return Promise.resolve()
    }
    if(this.isForbiddenToChangePlan()){
      this.mode = Modes.cantDowngrade
      return Promise.resolve()
    } 
    return this.toPlan(this.selected.id);
  }

  isForbiddenToChangePlan(){
    const { usage, addons } = this.$store.state.billing;
    const newPlanLimits = this.selected.limits
    
    return Object.keys(usage).some((key)=> {
      const addonLimits = +addons?.[key]?.addonLimit || 0;
      return +usage[key] > (+newPlanLimits[key] + addonLimits)
    })
  }

  handleBack() {
    this.mode = Modes.step1;
  }

  get width() {
    switch (this.mode) {
      case(Modes.cantDowngrade):
        return '600px';
      case(Modes.planDetails):
        return '800px';
      case(Modes.step1):
        const width = 202 * Math.min(this.plansList.length, 5) ;
        return `${width}px`;
      default:
        return '556px';
    }
  }

  get plansList() {
    return this.$store.state.billingPlans
  }

  get subscriptionInfo() {
    return this.$store.state.billing
  } 

  submit() {
    return this.updateSubscription(this.planId);
  }

  get isSubmitDisabled() {
    return this.estimate?.estimateType === 'lessThan50cents'
  }
}
